import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PromotionDetailStateService {
  private _promotionUid = signal<string | undefined>(undefined);

  promotionUid = this._promotionUid.asReadonly();

  open(uid: string) {
    this._promotionUid.set(uid);
  }

  close() {
    this._promotionUid.set(undefined);
  }
}
